export default {"src":"https://gfiber.com/support/_next/static/media/article_icon.9ed2fc01.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};